interface iDetailsParamsToKey {
  (params: { type: string; id: number | string }): string;
}
export const detailsParamsToKey: iDetailsParamsToKey = params => `${params.type}/${params.id}`;

export const getDataFromPageTab = (state, pageId, tabId) => {
  const currPageData = state[pageId].data;
  const currTabIndex = currPageData.tabs.findIndex(tab => tab.id === tabId);
  return currPageData.tabs[currTabIndex];
};
